/** Spanish (Español) — default language */
const es = {
  nav: {
    home: "Inicio",
    findJobs: "Buscar Empleos",
    companies: "Empresas",
    postAJob: "Publicar Empleo",
    signIn: "Iniciar Sesión",
    getStarted: "Comenzar",
    dashboard: "Panel",
    profile: "Perfil",
    signOut: "Cerrar Sesión",
    signedInAs: "Sesión iniciada como",
  },
  hero: {
    badge: "empleos activos · empresas contratando",
    h1a: "Encuentra trabajo",
    h1b: "cerca de ti",
    heroSubtitle: "Busca oportunidades por ubicación, horario y modalidad.",
    purposeLine: "InfoCityJobs conecta candidatos y empresas: creá tu perfil, prepará tu CV, buscá empleos y postulate a nuevas oportunidades.",
    subtitle: "Conectamos el mejor talento con las mejores empresas en todas las industrias.",
    searchJobs: "Buscar Empleos",
    keywordPlaceholder: "Cargo, habilidades o empresa",
    locationPlaceholder: "Ciudad o remoto",
    allTypes: "Todos los tipos",
    allLevels: "Todos los niveles",
    popular: "Popular",
    jobsLabel: "Empleos",
    companiesLabel: "Empresas",
    candidatesLabel: "Candidatos",
    useMyLocation: "Usar mi ubicación",
    forToday: "Para hoy",
    urgentOnly: "Urgentes",
    filtersBtn: "Filtros",
    filterRemote: "Remoto",
    filterPartTime: "Medio tiempo",
    filterNoExperience: "Sin experiencia",
    categoriesLabel: "Categorías",
    locating: "Buscando...",
    viewJobsBtn: "Ver empleos",
  },
  sections: {
    featuredLabel: "Top Oportunidades",
    featuredTitle: "Empleos Destacados",
    recommendedForYouShort: "Recomendados para ti",
    completeProfileForRecs: "Completa tu perfil para mejorar tus recomendaciones",
    jobCountSingular: "empleo",
    jobCountPlural: "empleos",
    featuredSubtitle: "Oportunidades seleccionadas de los mejores empleadores",
    featuredViewAll: "Ver todos",
    mapLabel: "Descubrimiento local",
    mapTitle: "Explora empleos en el mapa",
    mapSubtitle: "Descubre qué oportunidades hay en tu zona.",
    noJobsYet: "No hay empleos disponibles aún. ¡Sé el primero en publicar!",
    viewAllJobsBtn: "Ver todos los empleos",
    availableJobsLabel: "Empleos recientes",
    availableJobsTitle: "Empleos disponibles",
    companiesLabel: "Top Empleadores",
    companiesTitle: "Empresas que Contratan",
    companiesSubtitle: "Organizaciones líderes buscando talento activamente",
    companiesViewAll: "Ver todas",
    marketLabel: "Datos del Mercado",
    marketTitle: "Inteligencia del Mercado Laboral",
    marketSubtitle: "Benchmarks salariales, demanda de contratación y tendencias por ubicación en tiempo real.",
    employersLabel: "Para Empleadores",
    employersTitle: "¿Estás contratando?",
    employersSubtitle: "Publica empleos y llega a miles de candidatos calificados. Contrata más rápido, de forma más inteligente.",
    ecosystemLabel: "Red InfoCity",
    ecosystemTitle: "El Ecosistema InfoCity",
    ecosystemSubtitle: "Un ecosistema. Seis marketplaces especializados.",
    seeAllJobs: "Ver Todos los Empleos",
  },
  market: {
    salaryTitle: "Salario Promedio por Sector",
    salarySubtitle: "Anual, USD",
    demandTitle: "Demanda de Contratación",
    demandSubtitle: "Tendencias actuales",
    citiesTitle: "Ciudades con más Contrataciones",
    citiesSubtitle: "Mercados más activos",
    openJobsLabel: "empleos abiertos",
    remote: "Posiciones remotas",
    fullTime: "Empleos de tiempo completo",
    techSector: "Sector tecnológico",
    entryLevel: "Nivel de entrada",
    seniorLevel: "Nivel senior",
  },
  employerFeatures: [
    "Publicar empleos ilimitados",
    "Acceso a más de 125,000 candidatos verificados",
    "Seguimiento de candidatos integrado (ATS)",
    "Gestión del pipeline de contratación",
    "Análisis y reportes de conversión",
    "Coincidencia de candidatos con IA",
  ],
  cta: {
    postJobFree: "Publicar Empleo — Es Gratis",
    exploreCompanies: "Explorar Empresas",
    browseJobs: "Buscar Empleos",
    seeAllJobs: "Ver Todos los Empleos",
    youAreHere: "Estás aquí",
    comingSoon: "Próximamente",
    exploreNearby: "Explorar trabajos cerca de mí",
    postJob: "Publicar Empleo",
    viewFullMap: "Ver mapa completo",
  },
  jobCard: {
    today: "Hoy",
    yesterday: "Ayer",
    dAgo: "d",
    wAgo: "sem",
    moAgo: "meses",
    applicants: "postulantes",
    remote: "Remoto",
    upTo: "Hasta",
    perYear: "/año",
    perHour: "/hora",
    perMonth: "/mes",
    hybrid: "Híbrido",
    match: "compatible",
    salaryNotSpecified: "Salario no especificado",
    typeFullTime: "Tiempo completo",
    typePartTime: "Medio tiempo",
    typeContract: "Contrato",
    typeTemporary: "Temporal",
    typeFreelance: "Por proyecto / Freelance",
    typeInternship: "Prácticas / Pasantía",
    typeHourly: "Por horas",
    typeSeasonal: "Estacional",
    typeOther: "Otro",
    expNoExperience: "Sin experiencia",
    expEntry: "Inicial / Entry level",
    expJunior: "Junior",
    expMid: "Intermedio",
    expSenior: "Senior",
    expLead: "Lead / Líder",
    expManager: "Manager / Gerencia",
    expDirector: "Director",
    expExecutive: "Ejecutivo",
    expOther: "Otro",
    shareAria: "Compartir empleo",
  },
  map: {
    searchThisArea: "Buscar en esta zona",
    yourLocation: "Tu ubicación actual",
    viewJob: "Ver empleo",
    noJobsInArea: "No hay empleos con ubicación en esta zona",
    mapUnavailable: "Mapa no disponible en este momento",
    jobsAtLocation: "empleos en este punto",
  },
  jobsPage: {
    cityPlaceholder: "Ciudad...",
    listView: "Lista",
    mapView: "Mapa",
    radiusLabel: "Radio",
    nearMeBadge: "Cerca de mí",
    exitNearMe: "Salir",
    geoErrorBanner: "No pudimos obtener tu ubicación. Busca manualmente por ciudad.",
    dismiss: "Cerrar",
    jobsSuffix: "empleos",
    clear: "Limpiar",
    showAll: "Ver todas",
    showLess: "Ver menos",
    quickToday: "Hoy",
    quickUrgent: "Urgente",
    quickRemote: "Remoto",
    quickPartTime: "Medio tiempo",
    quickNoExp: "Sin exp.",
    backToAllJobs: "Todos los empleos",
    quickFiltersLabel: "Filtros rápidos",
    sectorLabel: "Sector",
    jobTypeLabel: "Tipo jornada",
    workModeLabel: "Modalidad",
    experienceLabel: "Experiencia",
    datePostedLabel: "Publicado",
    sortLabel: "Ordenar",
    anyOption: "Cualquiera",
    anyTime: "Cualquier momento",
    salaryLabel: "Salario",
    salaryMinPlaceholder: "Mín",
    salaryMaxPlaceholder: "Máx",
    prevPage: "Anterior",
    nextPage: "Siguiente",
    dateToday: "Hoy",
    date3days: "Últimos 3 días",
    date7days: "Última semana",
    date30days: "Último mes",
    sortNewest: "Más reciente",
    sortSalary: "Mayor salario",
    sortApplicants: "Más candidatos",
    categoryTech: "Tecnología",
    categoryFinance: "Finanzas",
    categoryHospitality: "Hostelería",
    categoryHealthcare: "Salud",
    categoryMarketing: "Marketing",
    categoryEducation: "Educación",
    categoryDesign: "Diseño",
    categoryLogistics: "Logística",
    workModeRemote: "Remoto",
    workModeHybrid: "Híbrido",
    workModeOnsite: "Presencial",
    locationLabel: "Ubicación",
    contractTypeLabel: "Tipo de contrato",
    quickNearMe: "Cerca de mí",
    geoRequesting: "Ubicando...",
    geoErrorDenied: "Permiso de ubicación denegado. Busca manualmente por ciudad.",
    noJobsInRadiusTitle: "Sin empleos en este radio",
    noJobsInRadiusDesc: "No encontramos empleos a {radius} km de tu ubicación. Probá ampliar el radio.",
  },
  filters: {
    title: "Filtros",
    clearAll: "Limpiar todo",
    applyFilters: "Aplicar Filtros",
    keyword: "Buscar empleos",
    location: "Ciudad o remoto",
    category: "Categoría",
    jobType: "Tipo de empleo",
    experience: "Experiencia",
    workMode: "Modalidad",
    allCategories: "Todas las categorías",
    allTypes: "Todos los tipos",
    allLevels: "Todos los niveles",
    anyMode: "Cualquiera",
    remoteOnly: "Solo remoto",
    onsiteOnly: "Solo presencial",
    found: "empleos encontrados",
    noJobs: "No se encontraron empleos",
    noJobsDesc: "Intenta ajustar los términos de búsqueda o filtros",
    clearFilters: "Limpiar filtros",
    searching: "Buscando...",
    search: "Buscar",
    remote: "Remoto",
    jobListings: "Listado de Empleos",
    findJobs: "Buscar Empleos",
  },
  jobDetail: {
    back: "Volver a empleos",
    applyNow: "Aplicar Ahora",
    applyExternally: "Aplicar Externamente",
    urgentBadge: "URGENTE",
    todayBadge: "HOY",
    immediateBadge: "INCORPORACIÓN INMEDIATA",
    remoteFromLabel: "Disponible desde",
    shiftLabel: "Turno",
    alreadyApplied: "Ya Aplicaste",
    signInToApply: "Inicia Sesión para Aplicar",
    description: "Descripción del Empleo",
    requirements: "Requisitos",
    benefits: "Beneficios",
    aboutRole: "Sobre el Puesto",
    whatWeNeed: "Lo que buscamos",
    perksLabel: "Beneficios y Ventajas",
    interested: "¿Interesado?",
    applyDesc: "Aplica en 2 minutos. No necesitas cuenta para empezar.",
    jobDetails: "Detalles del Empleo",
    companyLabel: "Empresa",
    jobTypeLabel: "Tipo de Empleo",
    categoryLabel: "Categoría",
    experienceLabel: "Experiencia",
    locationLabel: "Ubicación",
    postedLabel: "Publicado",
    applicantsLabel: "Postulantes",
    viewCompanyProfile: "Ver perfil de empresa",
    people: "personas",
    jobClosedTitle: "Esta oferta ya no acepta postulaciones",
    jobClosedDesc: "La empresa cerró o pausó este anuncio.",
    shareAria: "Compartir empleo",
    reportJob: "Reportar empleo",
    reportTitle: "Reportar este empleo",
    reportReasons: {
      possible_fraud: "Posible fraude",
      false_info: "Información falsa",
      discrimination: "Discriminación",
      inappropriate_content: "Contenido inapropiado",
      job_expired: "Empleo vencido",
      other: "Otro motivo",
    },
    reportDetailsPlaceholder: "Contanos más (opcional)",
    reportSubmit: "Enviar reporte",
    reportSent: "Gracias, recibimos tu reporte. Nuestro equipo lo va a revisar.",
    reportError: "No pudimos enviar el reporte. Probá de nuevo.",
    jobNotFound: "No encontramos esta oferta",
    backToJobs: "Volver a empleos",
    viewOfferExternal: "Ver oferta / Postular en sitio externo",
    descriptionPreview: "Extracto de la oferta",
    descriptionPreviewCaption: "Resumen proporcionado por Adzuna. Para ver el detalle completo, aplicá en el sitio original.",
    scheduleLabel: "Jornada",
    scheduleFullTime: "Jornada completa",
    schedulePartTime: "Media jornada",
    contractPermanent: "Contrato indefinido",
    contractTemporary: "Contrato temporal",
  },

  jobMatch: {
    cardTitle: "Compatibilidad con tu CV",
    compatible: "compatible",
    basedOnCv: "Calculado con tu CV real",
    viewAnalysis: "Ver análisis",
    noCvTitle: "Descubre tu compatibilidad",
    noCvDesc: "Crea o sube tu CV para conocer tu compatibilidad con este empleo.",
    createCvCta: "Crear mi CV",
    modalTitle: "Análisis de compatibilidad",
    matchesTitle: "Coincidencias",
    gapsTitle: "Faltantes",
    strengthsTitle: "Fortalezas",
    recoTitle: "Recomendaciones",
    strengthSkills: "Tienes {count} skills que esta oferta solicita",
    strengthExperience: "Tu nivel de experiencia es el ideal para este puesto",
    strengthRemote: "La modalidad remota de este empleo es totalmente compatible con tu perfil",
    strengthLocation: "Tu ubicación coincide con la del empleo",
    strengthAllReqs: "Tu CV refleja todos los requisitos indicados",
    strengthRelevantExp: "Tu experiencia como {position} es relevante para este puesto",
    recoKeywords: "Si realmente tienes experiencia en {list}, considera añadirla a tu CV",
    recoRequirements: "La oferta pide: \"{req}\" — verifica si tu CV lo refleja",
    recoExperience: "Esta oferta busca un perfil de nivel {level}; destaca en tu CV la experiencia real que más se acerque a ese nivel",
    recoHighlight: "Destaca tu experiencia en {skill} ya que es muy relevante para este puesto",
    recoRelocate: "Este empleo es presencial y no coincide con tu ubicación; menciona tu disponibilidad para reubicarte si aplica",
    strengthWorkMode: "Tu modalidad de trabajo preferida coincide con la de este empleo",
    recoWorkMode: "Este empleo no coincide con tu modalidad de trabajo preferida; revisa tus preferencias en tu Perfil Profesional",
    strengthSalary: "El rango salarial de este empleo cubre tu expectativa salarial",
    recoSalaryBelow: "El rango salarial de este empleo está por debajo de tu expectativa; revisa si aun así te interesa",
    recoAvailability: "No informaste tu disponibilidad; agrégala en tu Perfil Profesional para que las empresas la vean",
    recoLocationUnknown: "Ubicación no evaluada por falta de información.",
    adaptCvCta: "Adaptar mi CV a esta oferta",
    evaluatedNote: "Calculado sobre {max}/100 puntos evaluables según los datos de esta oferta",
    employer: {
      strengthSkills: "{name} tiene {count} skills que esta oferta solicita",
      strengthExperience: "El nivel de experiencia de {name} es el ideal para este puesto",
      strengthRemote: "La modalidad remota de este empleo es totalmente compatible con el perfil de {name}",
      strengthLocation: "La ubicación de {name} coincide con la del empleo",
      strengthAllReqs: "El CV de {name} refleja todos los requisitos indicados",
      strengthRelevantExp: "La experiencia de {name} como {position} es relevante para este puesto",
      recoKeywords: "Si {name} realmente tiene experiencia en {list}, sugerile que la añada a su CV",
      recoRequirements: "La oferta pide: \"{req}\" — verificá si el CV de {name} lo refleja",
      recoExperience: "Esta oferta busca un perfil de nivel {level}; revisá si {name} destaca en su CV la experiencia real que más se acerque a ese nivel",
      recoHighlight: "{name} podría destacar su experiencia en {skill} ya que es muy relevante para este puesto",
      recoRelocate: "Este empleo es presencial y no coincide con la ubicación de {name}; verificá su disponibilidad para reubicarse",
      strengthWorkMode: "La modalidad de trabajo preferida de {name} coincide con la de este empleo",
      recoWorkMode: "Este empleo no coincide con la modalidad de trabajo preferida de {name}",
      strengthSalary: "El rango salarial de este empleo cubre la expectativa salarial de {name}",
      recoSalaryBelow: "El rango salarial de este empleo está por debajo de la expectativa de {name}",
      recoAvailability: "{name} no informó su disponibilidad en su Perfil Profesional",
      recoLocationUnknown: "Ubicación no evaluada por falta de información.",
    },
  },
  cvAdapt: {
    modalTitle: "Adaptar mi CV a esta oferta",
    generating: "Generando tu CV adaptado con IA...",
    errorMsg: "No se pudo generar la adaptación. Intenta de nuevo en unos segundos.",
    close: "Cerrar",
    forJob: "Para el puesto de",
    summaryTitle: "Resumen profesional",
    original: "Original",
    adapted: "Adaptado",
    skillsTitle: "Habilidades (reordenadas)",
    experienceTitle: "Experiencia (reordenada)",
    suggestionsTitle: "Sugerencias — no incluidas en tu CV",
    suggestionsHint: "La oferta menciona estas habilidades. Agrégalas a tu CV solo si realmente tienes experiencia en ellas.",
    versionNameLabel: "Nombre de esta versión",
    defaultVersionPrefix: "CV adaptado para",
    discard: "Descartar",
    saveVersion: "Guardar como nueva versión",
    savedTitle: "¡Versión guardada!",
    downloadPdf: "Descargar PDF",
  },
  cvVersions: {
    title: "Mis versiones de CV",
    empty: "Aún no has adaptado tu CV para ninguna oferta.",
    adaptedBadge: "Adaptado",
    view: "Ver",
    downloadPdf: "Descargar PDF",
    delete: "Eliminar",
    deleteConfirm: "¿Eliminar esta versión de CV?",
  },
  apply: {
    title: "Aplicar al Puesto",
    at: "en",
    fullName: "Nombre Completo",
    email: "Correo Electrónico",
    phone: "Teléfono",
    linkedin: "LinkedIn (opcional)",
    uploadCv: "Cargar CV",
    uploadCvHint: "Click para subir PDF, DOC, DOCX",
    coverLetter: "Carta de Presentación",
    coverLetterPlaceholder: "¿Por qué eres el candidato ideal para este puesto?",
    submit: "Enviar Postulación",
    successTitle: "¡Postulación Enviada!",
    successMsg1: "¡Buena suerte! El equipo de",
    successMsg2: "estará en contacto.",
    continue: "Continuar Buscando",
    close: "Cerrar",
    applyPosition: "Aplicar al Puesto",
  },
  companies: {
    header: "Empresas",
    subtitle: "Encuentra empresas que están contratando.",
    searchPlaceholder: "Buscar empresas...",
    cityPlaceholder: "Ciudad",
    allIndustries: "Todas las industrias",
    found: "empresa(s) encontrada(s)",
    noResults: "No se encontraron empresas",
    noResultsDesc: "Intenta con un término de búsqueda diferente",
    openRoles: "puesto(s) abierto(s)",
    search: "Buscar",
    chipTech: "Tecnología",
    chipHospitality: "Hostelería",
    chipHealth: "Salud",
    chipFinance: "Finanzas",
    chipEducation: "Educación",
    chipRemote: "Remoto",
    filters: "Filtros",
    clearAll: "Limpiar",
    pageIndicator: "Página {page} de {total}",
    prevPage: "Página anterior",
    nextPage: "Página siguiente",
    loading: "Cargando...",
    filterPanelTitle: "Filtrar Empresas",
    countryLabel: "País",
    allCountries: "Todos los países",
    regionLabel: "Región / Estado",
    allRegions: "Todas las regiones",
    industryLabel: "Industria",
    sizeLabel: "Tamaño de Empresa",
    anySize: "Cualquier tamaño",
    minJobsLabel: "Mín. Puestos Abiertos",
    minJobsPlaceholder: "ej. 3",
    applyFilters: "Aplicar Filtros",
    sortMostJobs: "Más puestos abiertos",
    sortNewest: "Empresas más nuevas",
    sortAZ: "A–Z",
    sizeStartup: "Startup (1–10)",
    sizeSmall: "Pequeña (11–50)",
    sizeMedium: "Mediana (51–200)",
    sizeEnterprise: "Corporativa (1000+)",
    size_1_10: "Startup (1–10)",
    size_11_50: "Pequeña (11–50)",
    size_51_200: "Mediana (51–200)",
    size_201_500: "Media-grande (201–500)",
    size_501_1000: "Grande (501–1.000)",
    size_1000_plus: "Corporativa (+1.000)",
    countryNames: {
      unitedStates: "Estados Unidos", spain: "España", portugal: "Portugal", mexico: "México",
      argentina: "Argentina", colombia: "Colombia", brazil: "Brasil", unitedKingdom: "Reino Unido",
      france: "Francia", germany: "Alemania", canada: "Canadá", uruguay: "Uruguay",
    },
    industryNames: {
      technology: "Tecnología", finance: "Finanzas", healthcare: "Salud", marketing: "Marketing",
      education: "Educación", legal: "Legal", operations: "Operaciones", engineering: "Ingeniería",
      retail: "Comercio Minorista", media: "Medios", realEstate: "Bienes Raíces", hospitality: "Hostelería",
    },
  },
  companyProfile: {
    back: "Volver a empresas",
    opportunities: "Oportunidades",
    openPositions: "Posiciones Abiertas",
    about: "Acerca de",
    companyInfo: "Información de la Empresa",
    industryLabel: "Industria",
    sizeLabel: "Tamaño",
    hqLabel: "Sede",
    getDirections: "Cómo llegar",
    activeJobsLabel: "Empleos Activos",
    visitWebsite: "Visitar Sitio Web",
    lookingForJob: "¿Buscas empleo?",
    browseAll: "Ver todos los empleos",
    employees: "empleados",
    openRolesLabel: "Puestos Abiertos",
    teamSize: "Tamaño del Equipo",
    locationLabel: "Ubicación",
    noJobs: "Sin posiciones abiertas",
    noJobsDesc: "Vuelve pronto o explora otras empresas",
    websiteLabel: "Sitio web",
    companyFallback: "Empresa",
    browseAllDesc: "Explora las {count} posiciones abiertas en {name}.",
    foundedLabel: "Fundada en",
    benefitsLabel: "Beneficios",
    cultureLabel: "Cultura y ambiente",
  },
  auth: {
    signIn: "Iniciar Sesión",
    register: "Registrarse",
    emailLabel: "Correo Electrónico",
    passwordLabel: "Contraseña",
    fullNameLabel: "Nombre Completo",
    jobSeeker: "Candidato",
    employer: "Empleador",
    continueGoogle: "Continuar con Google",
    orEmail: "o continúa con correo electrónico",
    createAccount: "Crear Cuenta",
    alreadyHave: "¿Ya tienes cuenta?",
    noAccount: "¿No tienes cuenta?",
    welcomeBack: "¡Bienvenido! Inicia sesión para continuar.",
    joinUs: "Crea tu cuenta y comienza tu camino.",
    iAm: "Soy:",
    cancel: "Cancelar",
    signInAs: "Iniciar sesión como:",
    signInCandidate: "Candidato / Buscador de Empleo",
    signInEmployer: "Empleador / Empresa",
    namePlaceholder: "Juan Pérez",
    emailPlaceholder: "tu@ejemplo.com",
    passwordPlaceholder: "••••••••",
    passwordMinLength: "Mínimo 8 caracteres",
    acceptTermsPrefix: "Acepto los",
    acceptTermsAnd: "y la",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    marketingOptIn: "Quiero recibir novedades y oportunidades de InfoCityJobs",
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordSubtitle: "Ingresá tu correo y te enviaremos un enlace para restablecerla.",
    sendResetLink: "Enviar instrucciones",
    resetEmailSent: "Si existe una cuenta asociada a ese correo, recibirás instrucciones para restablecer tu contraseña.",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    resetPassword: "Restablecer contraseña",
    passwordUpdated: "Tu contraseña fue actualizada correctamente.",
    invalidToken: "Este enlace no es válido o ya fue utilizado.",
    expiredToken: "Este enlace expiró. Solicitá uno nuevo.",
    passwordMismatch: "Las contraseñas no coinciden.",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres.",
    backToLogin: "Volver a iniciar sesión",
    requestNewLink: "Solicitar un enlace nuevo",
    goToLogin: "Iniciar sesión",
  },
  userDash: {
    welcome: "Bienvenido de nuevo",
    applications: "Postulaciones",
    savedJobs: "Empleos Guardados",
    profile: "Perfil",
    editProfile: "Editar",
    noApplications: "Sin postulaciones aún",
    noApplicationsDesc: "Empieza a postularte a los empleos que te interesan",
    browseJobs: "Buscar Empleos",
    noSavedJobs: "Sin empleos guardados",
    noSavedJobsDesc: "Guarda empleos para revisarlos más tarde",
    findJobs: "Encontrar Empleos",
    myApplications: "Mis Postulaciones",
    applied: "Postulado",
    saveChanges: "Guardar Cambios",
    cancel: "Cancelar",
    fullNameLabel: "Nombre Completo",
    phoneLabel: "Teléfono",
    locationLabel: "Ubicación",
    linkedinLabel: "LinkedIn",
    bioLabel: "Sobre mí",
    bioPlaceholder: "Cuéntales a los empleadores sobre ti...",
    memberSince: "Miembro desde",
    stats: "estadísticas",
    savedLabel: "guardados",
    newMatches: "Nuevos Matches",
    recommendedTitle: "Empleos Recomendados para Ti",
    createCvBetterMatches: "Crear CV para mejores matches",
    unlockTitle: "Desbloquea el Matching con IA",
    unlockDesc: "Crea tu CV para obtener recomendaciones de empleo personalizadas con hasta 99% de compatibilidad.",
    getStarted: "Comenzar",
    noRecsTitle: "Aún no hay recomendaciones",
    noRecsDesc: "Agrega un CV para recibir recomendaciones de empleo personalizadas",
    editCV: "Editar CV",
    createCV: "Crear CV",
    noCvYetTitle: "Sin CV aún",
    noCvYetDesc: "Crea un CV profesional con asistencia de IA",
    createCvWithAI: "Crear CV con IA",
    positionsSuffix: "puestos",
    listedSuffix: "registradas",
    lastUpdated: "Última actualización",
    topSkills: "Principales Habilidades",
    networkLabel: "Red InfoCity",
    percentComplete: "completo",
    addMoreInfo: "— agrega más información para mejorar tu visibilidad",
    newJobSingular: "nuevo empleo",
    newJobPlural: "nuevos empleos",
    matchProfileDesc: "compatible(s) con tu perfil (80%+)",
    viewOffer: "Ver oferta",
    offerBanner_pending: "Oferta recibida",
    offerBanner_accepted: "Oferta aceptada",
    offerBanner_rejected: "Oferta rechazada",
    offerBanner_withdrawn: "Oferta retirada",
  },
  stages: {
    new_applicant: "Postulado",
    contacted: "Contactado",
    interview: "Entrevista",
    offer: "Oferta",
    hired: "Contratado",
    rejected: "Rechazado",
  },
  companyDash: {
    employerDash: "Panel del Empleador",
    overview: "Resumen",
    exploreNearby: "Explorar trabajos cerca de mí",
    postJob: "Publicar Empleo",
    myListings: "Mis Anuncios",
    applicants: "Candidatos",
    companyProfile: "Perfil de Empresa",
    activeJobs: "Empleos Activos",
    totalApplications: "Postulaciones",
    interviews: "Entrevistas",
    hired: "Contratados",
    recruitmentFunnel: "Embudo de Reclutamiento",
    hiringPipeline: "Pipeline de Contratación",
    listings: "Anuncios",
    viewAll: "Ver todos",
    recentActivity: "Actividad Reciente",
    latestApps: "Últimas Postulaciones",
    noJobs: "Sin empleos publicados",
    noJobsDesc: "Publica tu primer empleo para empezar a recibir candidatos",
    postFirstJob: "Publicar Primer Empleo",
    noApplicants: "Sin candidatos aún",
    noApplicantsDesc: "Las postulaciones aparecerán aquí cuando los candidatos apliquen",
    management: "Gestión",
    newListing: "Nuevo Anuncio",
    publishJob: "Publicar Anuncio de Empleo",
    editProfile: "Editar Perfil",
    saveProfile: "Guardar Perfil",
    keepUpToDate: "Mantén tu perfil actualizado para atraer mejores candidatos.",
    newJob: "Nuevo Empleo",
    applicantsCount: "postulantes",
    viewsCount: "visitas",
    postedOn: "Publicado",
    closeJobConfirm: "¿Cerrar este anuncio?",
    settings: "Configuración",
    viewJob: "Ver empleo",
  },
  postJobForm: {
    titleLabel: "Título del Puesto",
    titlePlaceholder: "ej. Desarrollador Senior de Software",
    locationLabel: "Ubicación",
    locationPlaceholder: "ej. Buenos Aires, Argentina",
    categoryLabel: "Categoría",
    jobTypeLabel: "Tipo de Empleo",
    experienceLabel: "Nivel de Experiencia",
    salaryMin: "Salario Mínimo (USD)",
    salaryMax: "Salario Máximo (USD)",
    descriptionLabel: "Descripción del Puesto",
    descriptionPlaceholder: "Describe el rol, responsabilidades y el candidato ideal...",
    requirementsLabel: "Requisitos",
    benefitsLabel: "Beneficios",
    externalLinkLabel: "Enlace Externo (opcional)",
    externalLinkPlaceholder: "https://tuempresa.com/empleos/aplicar",
    addRequirement: "+ Agregar requisito",
    addBenefit: "+ Agregar beneficio",
    isRemote: "Es un puesto remoto",
    publish: "Publicar Anuncio",
    successMsg: "¡Empleo publicado! Redirigiendo...",
    companyNameLabel: "Nombre de la Empresa",
    websiteLabel: "Sitio Web",
    industryLabel: "Industria",
    companySizeLabel: "Tamaño de la Empresa",
    headquartersLabel: "Sede",
    logoUrlLabel: "URL del Logo",
    descriptionLabel2: "Descripción",
  },
  pipeline: {
    new_applicant: "Nuevo",
    contacted: "Contactado",
    interview: "Entrevista",
    offer: "Oferta",
    hired: "Contratado",
    rejected: "Rechazado",
  },
  cvViewer: {
    loadError: "No pudimos cargar el CV. Intentá de nuevo.",
    noPreview: "Este archivo no se puede previsualizar. Descargalo para abrirlo.",
    back: "Volver",
    downloadPdf: "Descargar PDF",
  },
  notifyApplicant: {
    title: "¿Querés avisar a {name}?",
    message: "Mensaje",
    date: "Fecha",
    time: "Hora",
    endTime: "Hora de finalización",
    endTimeOptional: "Hora de finalización (opcional)",
    timezone: "Zona horaria",
    notes: "Notas / indicaciones al candidato",
    modality: "Modalidad",
    modality_in_person: "Presencial",
    modality_video: "Videollamada",
    modality_phone: "Telefónica",
    modality_other: "Otra",
    location: "Ubicación",
    locationPlaceholder: "Dirección de la entrevista",
    link: "Enlace de la videollamada",
    contactName: "Persona de contacto",
    contactRole: "Cargo del contacto",
    contactRolePlaceholder: "Ej: Hiring Manager",
    skip: "No avisar",
    send: "Enviar aviso",
    sendError: "No pudimos enviar el aviso. Intentá de nuevo.",
    sentToast: "Aviso enviado al candidato",
    rescheduledMessage: "Se actualizaron los detalles de tu entrevista. Revisá la nueva fecha y hora.",
    template: {
      contacted: "Hola {name}, vimos tu postulación a {job} y queremos contactarte para conversar más.",
      interview: "Hola {name}, nos gustaría invitarte a una entrevista para el puesto de {job}.",
      offer: "Hola {name}, ¡tenemos una oferta para vos por el puesto de {job}!",
      hired: "Hola {name}, ¡felicitaciones! Fuiste seleccionado/a para el puesto de {job}.",
      rejected: "Hola {name}, gracias por tu interés en {job}. Por ahora decidimos seguir con otro perfil, pero valoramos mucho tu postulación.",
    },
  },
  interviewForm: {
    sectionWhen: "CUÁNDO",
    sectionContact: "CONTACTO",
    sectionMessage: "MENSAJE PARA EL CANDIDATO",
    messagePlaceholder: "Agregá información adicional para el candidato...",
    linkPlaceholder: "Google Meet, Zoom, Teams...",
    phonePlaceholder: "Número de contacto",
    otherDetailsPlaceholder: "Describí cómo será la entrevista",
    cancel: "Cancelar",
  },
  notificationsInbox: {
    bannerLabel: "Actualizaciones de tus postulaciones",
  },
  companyBilling: {
    title: "Plan y Facturación",
    trialActive: "Prueba gratuita",
    planActive: "Plan activo",
    changePlan: "Cambiar plan",
    price: "Precio",
    expiresAt: "Vencimiento",
    accessUntil: "Acceso hasta",
    noExpiry: "Sin vencimiento",
    listings: "Publicaciones",
    unlimited: "Ilimitadas",
    noActivePlan: "No tenés un plan activo en este momento.",
    manageBilling: "Administrar facturación",
    portalError: "No se pudo abrir el portal de facturación. Intentá de nuevo.",
    paymentSuccessToast: "¡Pago confirmado! Tu plan se está activando.",
    paymentCancelledToast: "Pago cancelado. No se realizó ningún cargo.",
    pastDueWarning: "Hay un problema con tu método de pago.",
    pastDueCta: "Actualizar método de pago",
    statusPastDue: "Pago pendiente",
    statusCancelling: "Cancelación programada",
  },
  footer: {
    description: "El marketplace profesional de empleo que conecta candidatos y empresas: creá tu perfil profesional, preparás tu CV, buscás empleos y te postulás a nuevas oportunidades.",
    network: "Red InfoCity",
    seekersTitle: "Para Candidatos",
    employersTitle: "Para Empleadores",
    companyTitle: "InfoCity",
    browseJobs: "Buscar Empleos",
    companies: "Empresas",
    savedJobs: "Empleos Guardados",
    myApplications: "Mis Postulaciones",
    exploreNearby: "Explorar trabajos cerca de mí",
    postJob: "Publicar Empleo",
    employerDash: "Panel del Empleador",
    hiringSolutions: "Soluciones de Contratación",
    applicantTracking: "Seguimiento de Candidatos",
    aboutInfoCity: "Acerca de InfoCity",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    contact: "Contacto",
    cookiePrefs: "Preferencias de cookies",
    copyright: "InfoCity Ecosystem. Todos los derechos reservados.",
    partOf: "Parte del ecosistema de marketplaces",
  },
  legal: {
    backHome: "Volver al inicio",
    draftDisclaimer: "Este documento es un borrador operativo y no constituye asesoría jurídica final.",
    contactTitle: "Contacto",
    contactSubtitle: "¿Tenés alguna pregunta sobre tu cuenta, tus datos o estos Términos? Escribinos.",
    legalDataPending: "Los datos legales de la entidad responsable (razón social, domicilio, NIF/CIF) están pendientes de completar.",
  },
  cookies: {
    bannerText: "Usamos cookies necesarias para el funcionamiento del sitio y, con tu consentimiento, cookies de analítica para mejorar la experiencia.",
    learnMore: "Más información",
    necessary: "Necesarias (siempre activas)",
    analytics: "Analítica",
    preferences: "Preferencias de cookies",
    savePreferences: "Guardar preferencias",
    reject: "Rechazar",
    accept: "Aceptar",
  },
  privacy: {
    title: "Privacidad y datos",
    exportData: "Descargar mis datos",
    exportDataHint: "Recibí una copia en JSON de tu información personal.",
    marketingEmails: "Novedades y oportunidades por email",
    marketingEmailsHint: "Podés desactivarlo en cualquier momento. No afecta emails transaccionales.",
    changePasswordTitle: "Cambiar contraseña",
    changePasswordHint: "Al cambiarla, se cerrarán las sesiones abiertas en otros dispositivos.",
    currentPasswordLabel: "Contraseña actual",
    currentPasswordIncorrect: "La contraseña actual es incorrecta.",
    changePasswordButton: "Actualizar contraseña",
    passwordChangedSuccess: "Tu contraseña fue actualizada. Las demás sesiones se cerraron por seguridad.",
    deleteAccount: "Eliminar mi cuenta",
    deleteWarning: "Esta acción es irreversible. Se eliminarán tus datos personales, CV y foto de perfil. Tus postulaciones se conservarán de forma anonimizada como registro de las empresas correspondientes.",
    deleteConfirmWord: "eliminar",
    incorrectPassword: "La contraseña es incorrecta.",
    deleteFailed: "No pudimos eliminar tu cuenta. Intentá de nuevo.",
  },
  emailVerify: {
    title: "Verificá tu correo",
    body: "Te enviamos un enlace de verificación. Podés seguir usando InfoCityJobs mientras tanto.",
    resend: "Reenviar correo",
    resendSuccess: "Te enviamos un nuevo correo de verificación.",
    dismiss: "Ahora no",
    verifyingTitle: "Verificando tu correo...",
    successTitle: "¡Correo verificado!",
    successBody: "Tu cuenta quedó confirmada correctamente.",
    invalidLink: "Este enlace de verificación no es válido o ya fue utilizado.",
    expiredLink: "Este enlace de verificación expiró. Podés solicitar uno nuevo desde tu cuenta.",
    goToApp: "Ir a InfoCityJobs",
  },
  common: {
    cancel: "Cancelar",
    loading: "Cargando...",
  },
  ai: {
    title: "InfoCity IA",
    subtitle: "Asistente de Búsqueda de Empleos",
    placeholder: "Pregunta sobre empleos...",
    initialMessage: "¡Hola! Soy el Asistente IA de InfoCity. Te ayudo a buscar empleos, prepararte para entrevistas o guiarte por la plataforma. ¿Qué buscas hoy?",
    suggestions: ["Buscar empleos tech", "¿Cómo aplicar?", "Consejos de CV"],
    close: "Cerrar",
    send: "Enviar",
    error: "Lo siento, hubo un problema. Intenta de nuevo.",
    careerTitle: "Asistente de Carrera IA",
    careerSubtitle: "Orientación profesional personalizada",
    careerGreeting: "¡Hola {name}! Soy tu Asistente de Carrera IA. Puedo analizar tu CV, sugerirte empleos y ayudarte a avanzar en tu carrera. ¿Qué te gustaría saber?",
    careerGreetingGeneric: "¡Hola! Soy tu Asistente de Carrera IA. Puedo analizar tu CV, sugerirte empleos y ayudarte a avanzar en tu carrera. ¿Qué te gustaría saber?",
    usingCvHint: "Usando tu perfil de CV para respuestas personalizadas",
    usingCompanyHint: "Usando los datos de tu empresa para respuestas personalizadas",
    switchToChat: "Cambiar a chat general",
    switchToCareer: "Cambiar a modo carrera",
    careerModeBtn: "Carrera",
    chatModeBtn: "Chat",
    careerPlaceholder: "Pregunta sobre tu carrera...",
    careerSuggestions: ["¿Qué empleos coinciden con mi perfil?", "¿Cómo puedo mejorar mi CV?", "Ayúdame a prepararme para entrevistas"],
    // Rol-aware copy (candidate / employer / guest) — usado por AIChat.jsx
    subtitleCandidate: "Tu asistente de empleo",
    subtitleEmployer: "Asistente para empleadores",
    subtitleGuest: "Tu asistente de InfoCityJobs",
    greetingCandidate: "¡Hola {name}! Soy tu asistente de carrera de InfoCityJobs. Puedo ayudarte a encontrar oportunidades, mejorar tu perfil y CV, preparar entrevistas y gestionar tu búsqueda de empleo. ¿En qué te ayudo?",
    greetingCandidateGeneric: "¡Hola! Soy tu asistente de carrera de InfoCityJobs. Puedo ayudarte a encontrar oportunidades, mejorar tu perfil y CV, preparar entrevistas y gestionar tu búsqueda de empleo. ¿En qué te ayudo?",
    greetingEmployer: "¡Hola {name}! Soy tu asistente de contratación de InfoCityJobs. Puedo ayudarte a publicar mejores vacantes, encontrar candidatos, revisar perfiles, organizar entrevistas y gestionar tus procesos de selección. ¿Qué necesitás?",
    greetingEmployerGeneric: "¡Hola! Soy tu asistente de contratación de InfoCityJobs. Puedo ayudarte a publicar mejores vacantes, encontrar candidatos, revisar perfiles, organizar entrevistas y gestionar tus procesos de selección. ¿Qué necesitás?",
    greetingGuest: "¡Hola! Soy el asistente de InfoCityJobs. Puedo ayudarte a encontrar empleos, conocer cómo funciona la plataforma o explicarte cómo publicar vacantes.",
    suggestionsCandidate: ["Buscar empleos", "Mejorar mi CV", "Preparar entrevista", "Mejorar mi perfil"],
    suggestionsEmployer: ["Crear una vacante", "Buscar candidatos", "Mejorar un anuncio", "Gestionar entrevistas"],
    suggestionsGuest: ["Buscar empleos", "Soy candidato", "Soy empresa", "Cómo funciona InfoCityJobs"],
    placeholderCandidate: "Pregunta sobre tu carrera...",
    placeholderEmployer: "Pregunta sobre tu contratación...",
    placeholderGuest: "Pregunta sobre InfoCityJobs...",
    // IA Action Mode (Fase 3) — chrome de las tarjetas de resultado dentro del chat
    viewJobBtn: "Ver empleo",
    viewProfileBtn: "Ver perfil",
    saveBtn: "Guardar",
    unsaveBtn: "Quitar",
    compatibleLabel: "compatible",
    resultsRemote: "Remoto",
  },
  ecosystem: {
    youAreHere: "Estás aquí",
    prop: "Inmobiliario",
    jobs: "Empleos",
    cars: "Autos",
    shop: "Compras",
    boat: "Náutico",
    travel: "Viajes",
  },
  /* ── Backend API error messages ──────────────────────────────────────────── */
  errors: {
    emailTaken:        "El correo ya está registrado",
    invalidCredentials:"Correo o contraseña incorrectos",
    notAuthenticated:  "No has iniciado sesión",
    onlyCandidates:    "Solo los candidatos pueden postularse",
    onlyEmployers:     "Solo los empleadores pueden publicar empleos",
    alreadyApplied:    "Ya te has postulado a este empleo",
    jobNotFound:       "Empleo no encontrado",
    cvNotFound:        "CV no encontrado",
    aiNotConfigured:   "El servicio de IA no está disponible",
    parseFailed:       "No se pudo analizar el CV. Intenta con formato DOCX.",
    sessionExpired:    "Tu sesión expiró. Por favor inicia sesión nuevamente.",
    unknownError:      "Ocurrió un error inesperado. Inténtalo de nuevo.",
    accountSuspended:  "Tu cuenta fue suspendida. Contactá a soporte para más información.",
    googleLoginFailed: "No se pudo verificar tu cuenta de Google. Probá de nuevo.",
    googleEmailNotVerified: "Tu email de Google no está verificado. Verificalo en tu cuenta de Google e intentá de nuevo.",
    noFile:            "Selecciona un archivo primero",
    fileTooLarge:      "El archivo es demasiado grande",
    jobClosed:         "Esta oferta ya no acepta postulaciones",
    cvVersionNotFound: "Esa versión de tu CV ya no existe",
  },

  /* ── CompanyDashboard ──────────────────────────────────────────────────── */
  company: {
    dashTitle:         "Panel del Empleador",
    overviewLabel:     "Resumen",
    pipelineTitle:     "Pipeline de Contratación",
    funnel:            "Embudo de Reclutamiento",
    hiringPipeline:    "Pipeline de Contratación",
    activeJobs:        "Empleos Activos",
    totalApps:         "Postulaciones",
    interviews:        "Entrevistas",
    hired:             "Contratados",
    recentActivity:    "Actividad Reciente",
    latestApps:        "Últimas Postulaciones",
    activeListings:    "Empleos Activos",
    viewAll:           "Ver todos",
    noJobsYet:         "Sin empleos publicados aún",
    postFirstJob:      "Publica tu primer empleo para comenzar",
    noApplicants:      "Sin candidatos aún",
    appsAppearHere:    "Las postulaciones aparecerán aquí",
    interviewScheduledTitle: "Entrevista programada",
    editInterviewBtn: "Editar entrevista",
    editInterviewTitle: "Editar entrevista",
    scheduleInterviewTitle: "Programar entrevista",
    scheduleInterviewBtn: "Programar entrevista",
    saveInterviewChanges: "Guardar cambios",
    editCompany:       "Editar Perfil",
    saveCompany:       "Guardar Perfil",
    keepUpdated:       "Mantén tu perfil actualizado para atraer mejores candidatos.",
    companyName:       "Nombre de la Empresa",
    website:           "Sitio Web",
    industry:          "Industria",
    size:              "Tamaño de la empresa",
    sizePlaceholder:   "Seleccioná un rango",
    sizeHelp:          "Cantidad aproximada de empleados",
    size_1_10:         "1–10 empleados",
    size_11_50:        "11–50 empleados",
    size_51_200:       "51–200 empleados",
    size_201_500:      "201–500 empleados",
    size_501_1000:     "501–1.000 empleados",
    size_1000_plus:    "Más de 1.000 empleados",
    hq:                "Sede",
    address:           "Dirección exacta",
    addressPlaceholder: "Escribí una dirección y elegí una sugerencia",
    addressHint:       "La dirección exacta habilita el botón \"Cómo llegar\" en el perfil público.",
    legalName:         "Razón social",
    taxId:             "NIF/CIF/EIN",
    phone:             "Teléfono",
    verificationNeedsReviewTitle: "Verificación en revisión",
    verificationNeedsReviewDesc: "Detectamos algo para revisar en tus datos. Nuestro equipo lo va a revisar; podés seguir publicando empleos mientras tanto.",
    verificationPendingTitle: "Completá la verificación básica de tu empresa",
    verificationPendingDesc: "Agregá razón social, NIF/CIF/EIN y teléfono para obtener el sello de Verificación básica. Es automático, no bloquea publicar empleos.",
    verificationVerifiedDesc: "Formato y consistencia validados automáticamente.",
    logoUrl:           "URL del Logo",
    changeLogo:        "Cambiar logo",
    removeLogo:        "Eliminar logo",
    removeLogoConfirm: "¿Eliminar el logo de la empresa?",
    saveLogo:          "Guardar logo",
    logoInvalidType:   "Formato inválido. Usa JPEG, PNG o WEBP.",
    logoTooLarge:      "La imagen es demasiado grande (máx. 8MB).",
    logoSavedOk:       "Logo actualizado",
    logoRemovedOk:     "Logo eliminado",
    logoUploadError:   "No se pudo actualizar el logo. Intenta nuevamente.",
    description:       "Descripción",
    settings:          "Configuración",
    viewJob:           "Ver empleo",
    closeJob:          "¿Cerrar este anuncio?",
    applicants:        "postulantes",
    views:             "visitas",
    postedOn:          "Publicado",
    viewCv:            "Ver CV",
    primaryCvSubmitted: "CV principal",
    adaptedCvSubmitted: "CV adaptado para esta oferta",
    postFirstJobBtn: "Publicar tu Primer Empleo",
    pauseTooltip: "Pausar empleo", resumeTooltip: "Reactivar empleo", closeTooltip: "Cerrar empleo", editTooltip: "Editar empleo",
    topMatchingCandidates: "Mejores Candidatos Compatibles", allApplicantsTitle: "Todos los Candidatos",
    jobPositionLabel: "Puesto", allJobsOption: "Todos los Empleos",
    searchCandidatesLabel: "Buscar Candidatos", searchCandidatesPlaceholder: "Buscar por nombre, habilidad, palabra clave...",
    rankedByAI: "Clasificado por compatibilidad de IA",
    linkedinProfileLink: "Perfil de LinkedIn", profileLink: "Perfil", noCvUploaded: "Sin CV cargado",
    cancelBtn: "Cancelar",
    noCompanyProfileYet: "Aún no configuraste el perfil de tu empresa. Haz clic en \"Editar Perfil\" para comenzar.",
    profileCompleteness: "Perfil {pct}% completo",
    foundedYear: "Año de fundación",
    linkedinUrl: "LinkedIn",
    instagramUrl: "Instagram",
    culture: "Cultura y ambiente",
    culturePlaceholder: "Contanos cómo es trabajar en tu empresa...",
    benefits: "Beneficios",
    benefitsPlaceholder: "Un beneficio por línea, ej: Horario flexible",
    benefitsHint: "Escribí un beneficio por línea.",
    searchListingsPlaceholder: "Buscar por título...",
    filterAll: "Todos",
    sortNewest: "Más recientes",
    sortOldest: "Más antiguos",
    sortApplicants: "Más postulantes",
    noListingsMatch: "No hay anuncios que coincidan con esos filtros.",
    postErrorGeneric: "No se pudo publicar el empleo. Intenta nuevamente.",
    editErrorGeneric: "No se pudo actualizar el empleo. Intenta nuevamente.",
    stageErrorGeneric: "No se pudo actualizar el estado del candidato. Intenta nuevamente.",
    profileSaveError: "No se pudo guardar el perfil de la empresa. Intenta nuevamente.",
    profileSavedOk: "Perfil guardado correctamente", jobUpdatedOk: "Empleo actualizado correctamente",
    stageUpdatedOk: "Estado del candidato actualizado",
    locationNotVerifiedWarning: "No pudimos verificar esta ubicación en el mapa. El empleo se publicará igual, pero revisa que esté bien escrita.",
    salaryRangeError: "El salario mínimo no puede ser mayor que el salario máximo.",
    locationRequiredError: "Selecciona el país y la ciudad del empleo.",
    requirementPlaceholder: "Requisito",
    titlePlaceholder: "Ej: Ingeniero de Software Senior", locationPlaceholder: "Ej: Buenos Aires, Argentina",
    descriptionPlaceholder: "Describe el puesto, las responsabilidades y tu candidato ideal...",
    matchHigh: "Alta", matchMedium: "Media", matchLow: "Baja",
    matchSuffix: "de compatibilidad",
    topCandidatesEyebrow: "Compatibilidad", topCandidatesTitle: "Mejores candidatos",
    noCandidatesYet: "Todavía no tienes candidatos para comparar.", forJobLabel: "Para:",
    kpiActiveJobs: "Empleos activos", kpiNewCandidates: "Nuevos candidatos",
    kpiUpcomingInterviews: "Próximas entrevistas", kpiHires: "Contrataciones",
    kpiLast7Days: "Últimos 7 días", kpiLast30Days: "Últimos 30 días",
    interviewsEyebrow: "Agenda", upcomingInterviewsTitle: "Próximas entrevistas",
    interviewsUpcomingTab: "Próximas", interviewsHistoryTab: "Historial",
    noUpcomingInterviews: "No tienes entrevistas próximas.",
    noInterviewHistory: "Todavía no tienes entrevistas pasadas.",
    viewCandidateBtn: "Ver candidato",
    stageFilterAll: "Todos", sortByLabel: "Ordenar por",
    sortRecent: "Más recientes", sortMatchDesc: "Mayor compatibilidad", sortMatchAsc: "Menor compatibilidad",
    viewMatchAnalysisBtn: "Ver por qué",
    viewInterviewDetailsBtn: "Ver detalles",
    changeStageAria: "Cambiar etapa",
    changeStageBtn: "Cambiar etapa",
    candidateProfileAction: "Perfil",
    candidateMessageAction: "Mensaje",
    offerStatus_pending: "Oferta pendiente",
    offerStatus_accepted: "Oferta aceptada",
    offerStatus_rejected: "Oferta rechazada",
    offerStatus_withdrawn: "Oferta retirada",
    offerWithdrawBtn: "Retirar oferta",
    offerWithdrawConfirm: "¿Retirar esta oferta?",
    offerWithdrawnOk: "Oferta retirada",
    confirmHireBtn: "Confirmar contratación",
    confirmHireMsg: "¿Confirmar la contratación de {name} para {job}?",
  },
  offerModal: {
    title: "Crear oferta laboral",
    previewTitle: "Vista previa de la oferta",
    previewSubtitle: "Revisá los datos antes de enviar",
    jobTitle: "Cargo",
    workMode: "Modalidad",
    compMin: "Compensación",
    compMax: "Monto máximo",
    currency: "Moneda",
    period: "Período",
    period_hour: "por hora", period_day: "por día", period_week: "por semana", period_month: "por mes", period_year: "por año",
    compDetails: "Detalles de compensación",
    compDetailsPlaceholder: "Ej: más propinas, bono por desempeño...",
    employmentType: "Tipo de contratación",
    schedule: "Horario / Jornada",
    startDate: "Fecha prevista de inicio",
    location: "Ubicación",
    additionalDetails: "Detalles / condiciones adicionales",
    company: "Empresa",
    cancel: "Cancelar",
    continue: "Continuar",
    send: "Enviar oferta",
    sendError: "No se pudo enviar la oferta. Intenta de nuevo.",
    sentToast: "Oferta enviada",
  },
  offerDetail: {
    title: "Oferta recibida",
    status_accepted: "Oferta aceptada",
    status_rejected: "Oferta rechazada",
    status_withdrawn: "Esta oferta fue retirada por la empresa",
    accept: "Aceptar oferta",
    reject: "Rechazar oferta",
    confirmAccept: "¿Confirmás que querés aceptar esta oferta de {company} para {job}?",
    confirmReject: "¿Confirmás que querés rechazar esta oferta de {company} para {job}?",
    rejectReasonPrompt: "Motivo del rechazo (opcional)",
    actionError: "No se pudo procesar la acción. Intenta de nuevo.",
  },
  categories: {
    Technology: "Tecnología / IT", Finance: "Banca / Finanzas", Marketing: "Marketing / Publicidad", Design: "Diseño / Creatividad",
    Healthcare: "Medicina / Salud", Education: "Educación", Sales: "Ventas / Comercial", Operations: "Operaciones",
    Product: "Producto", Legal: "Legal", Hospitality: "Hostelería", Logistics: "Logística / Transporte",
    Administration: "Administración", CustomerService: "Atención al cliente", Construction: "Construcción",
    Accounting: "Contabilidad", FoodService: "Gastronomía / Restaurantes", Tourism: "Hotelería / Turismo",
    Engineering: "Ingeniería", SkilledTrades: "Oficios / Mantenimiento", Manufacturing: "Producción / Manufactura",
    HumanResources: "Recursos Humanos", Retail: "Retail / Comercio", Security: "Seguridad", Services: "Servicios",
    Other: "Otros",
  },
  companyVisibility: {
    question: "¿Cómo quieres mostrar la empresa en esta oferta?",
    showCompany: "Mostrar mi empresa",
    hideCompany: "Publicar como empresa confidencial",
    chooseDisplayLabel: "¿Qué quieres mostrar en su lugar?",
    previewTitle: "Así aparecerá tu oferta",
    hiddenNotice: "Tu nombre real NO será visible públicamente en esta oferta.",
    presetOther: "Otra",
    presetOtherPlaceholder: "Escribe cómo quieres que aparezca",
    presetOtherExample: "Ej: Importante empresa del sector hotelero",
    preset_important: "Importante empresa",
    preset_important_sector: "Importante empresa del sector {sector}",
    preset_important_sector_generic: "Importante empresa del sector",
    preset_leader_sector: "Empresa líder del sector {sector}",
    preset_leader_sector_generic: "Empresa líder del sector",
    preset_recognized: "Reconocida empresa del sector {sector}",
    preset_recognized_generic: "Reconocida empresa",
    preset_international: "Empresa internacional",
    preset_multinational: "Multinacional",
    preset_growing: "Empresa en crecimiento",
    preset_startup: "Startup en crecimiento",
    preset_group: "Grupo empresarial",
    preset_consultancy: "Consultora especializada",
  },
  companyAccess: {
    title: "Elegí el plan ideal para tu empresa",
    subtitle: "Publicá tus empleos y empezá a recibir candidatos.",
    limitTitle: "Alcanzaste el límite de publicaciones de tu plan",
    limitSubtitle: "Elegí otro plan con más publicaciones incluidas o esperá a tu próxima renovación.",
    noPlansAvailable: "Los planes para tu país estarán disponibles próximamente. Contactá al equipo de InfoCityJobs.",
    choosePlan: "Elegir plan",
    continueToPayment: "Continuar al pago",
    startTrial: "Empezar prueba gratis",
    days: "días",
    listingsIncluded: "publicaciones incluidas",
    formPreservedNote: "Tu anuncio quedó guardado tal como lo dejaste — no se perdió nada.",
    activatedToast: "Plan activado. Ya podés publicar tu empleo.",
    trialStartedToast: "Período de prueba iniciado. Ya podés publicar tu empleo.",
    alreadySubscribedNote: "Ya tenés una suscripción activa. Gestioná tu plan, método de pago o cancelación desde Administrar Facturación.",
    durationUnit: { day: "día", week: "semana", month: "mes", year: "año", unlimited: "sin vencimiento" },
  },
  jobDetailExtra: {
    applyPosition:     "Aplicar al Puesto",
    at:                "en",
    fullNameReq:       "Nombre Completo *",
    emailReq:          "Correo Electrónico *",
    phoneReq:          "Teléfono *",
    linkedinOpt:       "LinkedIn (opcional)",
    uploadCV:          "Cargar CV",
    uploadHint:        "Click para subir PDF, DOC, DOCX",
    coverLetter:       "Carta de Presentación",
    coverHint:         "¿Por qué eres el candidato ideal?",
    submitApp:         "Enviar Postulación",
    successTitle:      "¡Postulación Enviada!",
    successMsg:        "¡Buena suerte! El equipo estará en contacto.",
    continue:          "Continuar Buscando",
    closeModal:        "Cerrar",
    selectCvTitle:     "¿Con qué CV quieres postularte?",
    primaryCvLabel:    "CV principal",
    recommendedBadge:  "Recomendado para esta oferta",
    adaptCvSecondaryCta: "Adaptar mi CV a esta oferta",
    noCvTitle:         "Necesitas un CV para postularte",
    noCvDesc:          "Crea tu CV profesional para poder enviar postulaciones.",
    createCvCta:       "Crear mi CV",
    versionDeletedError: "Esa versión de tu CV ya no existe. Elige otra opción.",
    usedCvLabel:       "CV utilizado",
    viewApplicationsCta: "Ver mis postulaciones",
  },

  /* ── Professional Profile ──────────────────────────────────────────────── */
  profProfile: {
    back:              "Atrás",
    openToWorkBadge:   "✓ Disponible",
    summary:           "Resumen Profesional",
    workExp:           "Experiencia Laboral",
    education:         "Educación",
    skills:            "Habilidades",
    languages:         "Idiomas",
    certifications:    "Certificaciones",
    portalCompat:      "Compatibilidad de Portales",
    activeIn:          "Activo en",
    editProfile:       "Editar Perfil",
    downloadCV:        "Descargar CV",
    completeness:      "Completitud del Perfil",
    completePrompt:    "Completar perfil →",
    present:           "Actual",
  },

  lang: {
    es: "Español",
    en: "English",
    pt: "Português",
  },

  /* ── Dashboard tabs ─────────────────────────────────── */
  tabs: {
    recommended:       "Recomendados",
    applications:      "Postulaciones",
    savedJobs:         "Empleos Guardados",
    myCV:              "Mi CV",
    professionalProfile: "Perfil Profesional",
    overview:          "Resumen",
    exploreNearby: "Explorar trabajos cerca de mí",
    postJob:           "Publicar Empleo",
    myListings:        "Mis Anuncios",
    applicants:        "Candidatos",
    companyProfile:    "Perfil de Empresa",
  },

  /* ── Hiring Pipeline ────────────────────────────────── */
  hiring: {
    pipelineTitle:     "Pipeline de Contratación",
    pipelineFunnel:    "Embudo de Reclutamiento",
    topCandidates:     "Top Candidatos",
    allApplicants:     "Todos los Candidatos",
    hiringProbability: "Probabilidad de Contratación",
    high:              "Alta",
    medium:            "Media",
    low:               "Baja",
    rankedByAI:        "Ordenado por IA",
    filterByJob:       "Filtrar por puesto",
    allJobs:           "Todos los puestos",
    searchCandidates:  "Buscar candidatos",
    searchPlaceholder: "Nombre, skill, palabra clave...",
    viewProfile:       "Ver Perfil",
    viewCV:            "Ver CV",
    noCV:              "Sin CV adjunto",
    coverLetter:       "Carta de Presentación",
  },

  /* ── CV Builder ─────────────────────────────────────── */
  cv: {
    builderTitle:      "Crear CV",
    builderSubtitle:   "Crea tu CV profesional con asistencia IA en minutos",
    privacyHint:       "Tu información profesional podrá ser visible para empresas cuando actives \"Disponible para trabajo\" o cuando te postules a una vacante.",
    aiPowered:         "Con IA",
    stepPersonal:      "Datos Personales",
    stepSummary:       "Resumen",
    stepExperience:    "Experiencia",
    stepEducation:     "Educación",
    stepSkills:        "Habilidades",
    stepLanguages:     "Idiomas",
    stepPreview:       "Vista Previa",
    fullName:          "Nombre Completo",
    professionalTitle: "Título Profesional",
    yearsExp:          "Años de Experiencia",
    titlePlaceholder:  "Ej. Ingeniero Senior de Software",
    summaryHint:       "Describe tu trayectoria y deja que la IA lo mejore automáticamente.",
    generateAI:        "Generar con IA",
    aiImprove:         "Mejorar con IA",
    suggestSkills:     "Sugerir Skills con IA",
    uploadCVBtn:       "Subir PDF / DOCX",
    importCVHint:      "¿Ya tienes un CV? Importarlo automáticamente",
    parsing:           "Analizando...",
    parsedOK:          "CV analizado e importado",
    parseFailed:       "Error al analizar. Intenta con DOCX.",
    aiImproved:        "¡IA mejoró tu texto!",
    addTextFirst:      "Agrega texto primero",
    company:           "Empresa",
    position:          "Puesto",
    startDate:         "Fecha inicio",
    endDate:           "Fecha fin",
    currentJob:        "Actual",
    responsibilities:  "Responsabilidades",
    institution:       "Institución",
    degree:            "Título",
    field:             "Área de estudio",
    year:              "Año",
    skillsHint:        "Escribe una habilidad y presiona Enter",
    industriesHint:    "Ej. Tecnología, Finanzas...",
    languagesHint:     "Ej. Inglés (Nativo), Español (B2)...",
    certHint:          "Ej. AWS, PMP, Google Analytics...",
    industries:        "Industrias",
    addExperience:     "+ Agregar Experiencia",
    addEducation:      "+ Agregar Educación",
    saveCV:            "Guardar CV",
    saving:            "Guardando...",
    saved:             "CV guardado",
    downloadPDF:       "Descargar PDF",
    downloadWord:      "Descargar Word",
    goToDashboard:     "Ir al Dashboard",
    toDashboard:       "Ver Dashboard",
    cvStrength:        "Fortaleza del CV",
    cvScore:           "Puntaje CV",
    suggestions:       "Sugerencias",
    previous:          "Anterior",
    next:              "Siguiente",
    previewTitle:      "Vista Previa y Guardar",
    skillsFieldLabel:     "Habilidades (presiona Enter para agregar)",
    languagesFieldLabel:  "Idiomas (presiona Enter para agregar)",
    certFieldLabel:       "Certificaciones (presiona Enter para agregar)",
    certDetailHint:       "Podés agregar organización, fechas y credencial desde tu Perfil Profesional.",
    summaryPlaceholder:   "Ingeniero de software con más de 5 años construyendo aplicaciones web escalables...",
    companyPlaceholder:   "Ej: TechCorp S.A.",
    positionPlaceholder:  "Ej: Ingeniero Senior",
    responsibilitiesPlaceholder: "Describe tus principales responsabilidades y logros...",
    institutionPlaceholder: "Ej: Universidad Nacional",
    degreePlaceholder:    "Ej: Licenciatura",
    fieldPlaceholder:     "Ej: Ciencias de la Computación",
    stepCounterPrefix:    "Paso",
    stepCounterOf:        "de",
    viewStages:           "Ver etapas",
    saveHint:             "Presiona \"Guardar CV\" para finalizar y descargar tu currículum.",
  },

  /* ── Mobile Bottom Navigation (candidates) ─────────────── */
  bottomNav: {
    search:       "Buscar",
    recommended:  "Recomendados",
    applications: "Postulaciones",
    myJobs:       "Mis empleos",
    messages:     "Mensajes",
    whoViewedMe:  "Quién me ve",
    cv:           "CV",
    profile:      "Perfil",
    home:         "Inicio",
    overview:     "Resumen",
    listings:     "Anuncios",
    post:         "Publicar",
    applicants:   "Candidatos",
    panel:        "Mi Panel",
  },

  /* ── Mobile compact header + hamburger drawer (candidates) ── */
  mobileHeader: {
    menu:          "Menú",
    notifications: "Notificaciones",
    settings:      "Configuración",
    myProfile:     "Mi perfil",
    guestSubtitle: "Encontrá tu próximo empleo",
    hiringCta:     "¿Buscás candidatos?",
    sectionAccount: "Cuenta",
    sectionExplore: "Explorar",
    sectionHelp:    "Ayuda",
    help:           "Ayuda",
  },

  /* ── Mis Empleos (Guardados / Postulados / Entrevistas) ── */
  myJobs: {
    title: "Mis empleos",
    tabSaved: "Guardados", tabApplications: "Postulados", tabInterviews: "Entrevistas",
    savedEmptyTitle: "Aún no tienes empleos guardados",
    savedEmptyDesc: "Guarda los empleos que te interesen para encontrarlos fácilmente aquí.",
    savedCta: "Buscar empleos",
    appsEmptyTitle: "Aún no tienes postulaciones",
    appsEmptyDesc: "Cuando te postules a un empleo podrás seguir su estado desde aquí.",
    interviewsEmptyTitle: "No tienes entrevistas programadas",
    interviewsEmptyDesc: "Cuando una empresa programe una entrevista aparecerá aquí.",
    interviewsUpcomingTab: "Próximas", interviewsHistoryTab: "Historial",
    interviewsHistoryEmptyTitle: "Todavía no tienes entrevistas pasadas",
    interviewsHistoryEmptyDesc: "Las entrevistas que ya pasaron aparecerán aquí.",
    interviewLabel: "Entrevista",
    withLabel: "Con",
    addToCalendar: "Agregar al calendario",
    calendarPositionLabel: "Entrevista para",
    calendarCompanyLabel: "Empresa",
    calendarContactRoleLabel: "Cargo del contacto",
    calendarModalityLabel: "Modalidad",
    calendarLinkLabel: "Enlace de entrevista",
    calendarNotesLabel: "Notas",
    calendarFooter: "Creado desde InfoCityJobs",
  },

  /* ── Selector "Agregar al calendario" ── */
  calendarSheet: {
    title: "Agregar al calendario",
    googleTitle: "Google Calendar",
    googleSubtitle: "Agregar con Google Calendar",
    appleTitle: "Apple Calendar",
    appleSubtitle: "Agregar al calendario de iPhone, iPad o Mac",
    cancel: "Cancelar",
  },

  /* ── Quién me ve ── */
  whoViewedMe: {
    title: "Quién me ve",
    emptyTitle: "Todavía no tienes visitas recientes",
    emptyDesc: "Cuando una empresa encuentre o visite tu perfil, aparecerá aquí.",
    cta: "Mejorar mi perfil",
    relatedTo: "Relacionado con",
  },

  /* ── Perfil hub (mobile) ── */
  profileHub: {
    companiesCanFindYou: "Las empresas pueden encontrarte",
    onlyAppliedCompaniesCanSeeYou: "Solo las empresas donde postulás pueden verte",
    visibilitySaveError: "No se pudo guardar el cambio, intentá de nuevo.",
    visibilityOnTitle: "Perfil visible",
    visibilityOnDesc: "Todas las empresas registradas pueden encontrar y consultar tu perfil profesional.",
    visibilityOffTitle: "Perfil privado",
    visibilityOffDesc: "Tu perfil no aparece en búsquedas, Talent Pool, recomendaciones ni descubrimiento de candidatos. Solo pueden verlo las empresas a cuyos empleos hayas postulado.",
    rowProfessionalProfile: "Perfil profesional",
    rowCV: "CV",
    rowContact: "Información de contacto",
    rowCountryLanguage: "País e idioma",
    rowSettings: "Configuración",
    rowAccount: "Cuenta",
    rowPrivacy: "Privacidad",
    rowHelp: "Ayuda",
    logout: "Cerrar sesión",
  },
  settingsHub: {
    back: "Volver",
    soundLabel: "Sonido de mensajes",
    soundHint: "Reproduce un sonido cuando llega un mensaje nuevo.",
  },

  contact: {
    postalCodeLabel: "Código postal",
    postalCodePrivate: "Visible solo para ti",
  },

  countryLanguage: {
    countryLabel: "País",
    languageLabel: "Idioma",
  },

  /* ── Mensajes (candidato ↔ empresa) ── */
  messages: {
    title: "Mensajes",
    emptyTitle: "Aún no tienes mensajes",
    emptyDesc: "Cuando una empresa quiera ponerse en contacto contigo, sus mensajes aparecerán aquí.",
    selectConversation: "Selecciona una conversación",
    messagePlaceholder: "Escribe un mensaje…",
    send: "Enviar",
    sendMessage: "Enviar mensaje",
    sendError: "No pudimos enviar el mensaje. Intenta de nuevo.",
    pushBannerText: "Activá las notificaciones para no perderte mensajes nuevos, aunque no tengas InfoCityJobs abierta.",
    pushBannerEnable: "Activar notificaciones",
    soundOnTooltip: "Sonido activado — clic para silenciar",
    soundOffTooltip: "Sonido silenciado — clic para activar",
    typingIndicator: "Escribiendo…",
    deleteConversationConfirm: "¿Eliminar esta conversación? Solo se eliminará de tu bandeja — la otra parte seguirá viéndola.",
    deleteConversationTooltip: "Eliminar conversación",
  },

  notifOnboarding: {
    title: "Activá las notificaciones",
    body: "Recibí mensajes, entrevistas y novedades importantes aunque no tengas InfoCityJobs abierta.",
    activate: "Activar notificaciones",
    notNow: "Ahora no",
  },

  /* ── Professional Profile ───────────────────────────── */
  profile: {
    universal:         "Perfil Profesional Universal InfoCity",
    myProfile:         "Perfil",
    editProfile:       "Editar Perfil",
    viewPublic:        "Cómo me ven las empresas",
    completeness:      "Completitud del Perfil",
    completeProfile:   "Completar perfil →",
    about:             "Acerca de",
    career:            "Carrera",
    academic:          "Académica",
    workExp:           "Experiencia Laboral",
    portalCompat:      "Compatibilidad de Portales",
    activeIn:          "Activo en",
    openToWork:        "Disponible para trabajar",
    openToWorkDesc:    "Permite que empresas descubran tu perfil en el Talent Pool",
    openToWorkActive:  "Tu perfil es visible para empresas en el Talent Pool",
    addTitle:          "Agrega tu título",
    addLocation:       "Agrega ubicación",
    addExperience:     "Agrega experiencia",
    yearsExp:          "años de experiencia",
    present:           "Actual",
  },

  /* ── Professional Profile tab (Mi Perfil Profesional) ──── */
  profTab: {
    unnamedCandidate:   "Candidato/a",
    availableStatus:    "Disponible para nuevas oportunidades",
    notAvailableStatus: "No disponible actualmente",
    privacyHint:        "Al activar \"Disponible para trabajo\", tu perfil e información profesional serán visibles para empresas de la plataforma.",
    completeProfileCta: "Completar perfil",
    completeCtaBasic_info: "Completar datos básicos",
    completeCtaSummary: "Agregar resumen",
    completeCtaExperience: "Agregar experiencia",
    completeCtaEducation: "Agregar formación",
    completeCtaSkills: "Agregar habilidades",
    completeCtaLanguages: "Agregar idiomas",
    completeCtaIndustries: "Agregar industria",
    completeCtaPreferences: "Agregar preferencias laborales",
    completeCtaCv_document: "Generar tu CV",
    completeCtaPhoto: "Agregar foto",
    save: "Guardar", cancel: "Cancelar", delete: "Eliminar", saving: "Guardando...",

    basicInfoTitle: "Datos básicos",
    nameLabel: "Nombre completo",
    titleFieldLabel: "Titular profesional",
    titleFieldPlaceholder: "Ej: Técnico de Telecomunicaciones",
    locationFieldLabel: "Ubicación",
    phoneFieldLabel: "Teléfono",
    linkedinFieldLabel: "LinkedIn",

    aboutTitle: "Sobre mí",
    summaryEmpty: "Contanos sobre tu trayectoria profesional para que las empresas te conozcan mejor.",
    addSummaryBtn: "Agregar resumen",
    editSummaryBtn: "Editar resumen",
    improveWithAI: "Mejorar con IA",
    summaryPlaceholder: "Describe tu experiencia, fortalezas y objetivos profesionales...",

    experienceTitle: "Experiencia laboral",
    experienceEmpty: "No agregaste experiencia todavía.",
    addExperienceBtn: "Agregar experiencia",
    editExperienceTitle: "Editar experiencia",
    addExperienceTitle: "Agregar experiencia",
    deleteExperienceConfirm: "¿Eliminar esta experiencia?",
    positionLabel: "Cargo",
    companyLabel: "Empresa",
    startDateLabel: "Fecha inicio",
    endDateLabel: "Fecha fin",
    currentJobLabel: "Trabajo actual aquí",
    experienceLocationLabel: "Ubicación (opcional)",
    descriptionLabel: "Descripción",

    educationTitle: "Educación",
    educationEmpty: "No agregaste educación todavía.",
    addEducationBtn: "Agregar educación",
    editEducationTitle: "Editar educación",
    addEducationTitle: "Agregar educación",
    deleteEducationConfirm: "¿Eliminar esta educación?",
    institutionLabel: "Centro educativo",
    degreeLabel: "Título",
    fieldLabel: "Campo de estudio",
    yearLabel: "Año",

    skillsEmpty: "Agregá tus habilidades para destacar en las búsquedas.",
    addSkillBtn: "Agregar habilidad",
    editSkillsTitle: "Editar habilidades",
    skillsHint: "Escribe una habilidad y presiona Enter",
    showAllSkills: "Ver todas ({count})",
    showLessSkills: "Ver menos",

    languagesEmpty: "Agregá los idiomas que hablás.",
    addLanguageBtn: "Agregar idioma",
    editLanguagesTitle: "Editar idiomas",
    languageNamePlaceholder: "Idioma (ej. Inglés)",
    languageLevelLabel: "Nivel",
    levelNative: "Nativo",
    levelAdvanced: "Avanzado (C1)",
    levelIntermediate: "Intermedio (B2)",
    levelBasic: "Básico (A2)",
    addLanguageAction: "Agregar",

    preferencesTitle: "Preferencias laborales",
    preferencesEmpty: "Contanos qué tipo de empleo estás buscando para mejorar tus recomendaciones.",
    addPreferencesBtn: "Agregar preferencias",
    editPreferencesTitle: "Preferencias laborales",
    desiredPositionsLabel: "Puestos deseados",
    desiredPositionsHint: "Escribe un puesto y presiona Enter",
    desiredCategoriesLabel: "Categorías profesionales",
    desiredLocationsLabel: "Ubicaciones deseadas",
    desiredLocationsHint: "Escribe una ubicación y presiona Enter",
    preferredModalityLabel: "Modalidad",
    preferredShiftLabel: "Tipo de jornada",
    preferredContractLabel: "Tipo de contrato",
    availabilityLabel: "Disponibilidad",
    availabilityImmediate: "Inmediata",
    availability2Weeks: "En 2 semanas",
    availability1Month: "En 1 mes",
    availabilityNegotiable: "A convenir",
    salaryMinExpectationLabel: "Salario mínimo deseado",
    willingToRelocateLabel: "Disponibilidad para cambiar de residencia",
    willingToTravelLabel: "Disponibilidad para viajar",

    cvDocTitle: "CV y documentos",
    cvDocUpdated: "Actualizado",
    cvDocEmpty: "Todavía no creaste tu CV.",
    cvDocCreateBtn: "Crear mi CV",
    viewCvBtn: "Ver CV",

    missingHintBasic_info: "Completá tus datos básicos para que las empresas te encuentren.",
    missingHintSummary: "Agregá un resumen profesional para destacar tu perfil.",
    missingHintExperience: "Agregá tu experiencia laboral para mejorar tus postulaciones.",
    missingHintEducation: "Agregá tu educación para completar tu perfil.",
    missingHintSkills: "Agregá al menos 3 habilidades para aparecer en más búsquedas.",
    missingHintLanguages: "Agregá los idiomas que hablás.",
    missingHintIndustries: "Agregá al menos una industria para mejorar tus recomendaciones.",
    missingHintPreferences: "Agregá tus preferencias laborales para mejorar tus recomendaciones.",
    missingHintCv_document: "Generá tu CV para poder postularte a empleos.",
    missingHintPhoto: "Agregá una foto de perfil para causar una mejor primera impresión.",

    avatarTitle: "Foto de perfil",
    cropAvatarTitle: "Ajustá tu foto",
    changePhotoBtn: "Cambiar foto",
    deleteAvatarConfirm: "¿Eliminar tu foto de perfil?",
    avatarInvalidType: "Formato inválido. Usa JPEG, PNG o WEBP.",
    avatarTooLarge: "La imagen es demasiado grande (máx. 8MB).",

    companyViewCta: "Cómo me ven las empresas",
    companyPreviewNote: "Esta es una vista previa de cómo puede presentarse tu perfil profesional a las empresas.",
    backToEditProfile: "Volver a editar perfil",

    industriesTitle: "Industrias",
    industriesEmpty: "No agregaste industrias todavía.",
    addIndustryBtn: "Agregar industria",
    editIndustriesTitle: "Editar industrias",
    industriesHint: "Escribe una industria y presiona Enter",

    certificationsTitle: "Certificaciones",
    certificationsEmpty: "No agregaste certificaciones todavía.",
    addCertificationBtn: "Agregar certificación",
    editCertificationTitle: "Editar certificación",
    addCertificationTitle: "Agregar certificación",
    deleteCertificationConfirm: "¿Eliminar esta certificación?",
    certNameLabel: "Nombre de la certificación",
    certNameRequired: "Ingresá el nombre de la certificación.",
    certIssuerLabel: "Organización emisora",
    certIssueDateLabel: "Fecha de obtención",
    certExpiryDateLabel: "Fecha de vencimiento",
    certNoExpiryLabel: "No vence",
    certCredentialIdLabel: "ID de credencial (opcional)",
    certCredentialUrlLabel: "URL de credencial (opcional)",
    certInvalidUrl: "La URL de la credencial no es válida.",
    viewCredentialLink: "Ver credencial",

    savedSuccess: "Perfil actualizado",
  },

  /* ── Homepage new sections ──────────────────────────── */
  homeSections: {
    cvTitle:           "Tu CV",
    cvSubtitle:        "Completá tu perfil y mejorá tus postulaciones.",
    cvComplete:        "completo",
    cvStateIncomplete: "Completa tu perfil",
    createMyCV:        "Crear CV",
    continueCV:        "Continuar CV",
    viewEditCV:        "Ver o editar CV",
    hiringQuestion:    "¿Buscás candidatos?",
    postJobLink:       "Publicá un empleo",
    uploadMyCV:        "Subir mi CV",
    freeCVBuilder:     "CV Gratuito",
    freeCVDesc:        "Sin costo, sin tarjeta",
    aiImprovements:    "Mejoras con IA",
    aiImprovDesc:      "Descripciones mejoradas automáticamente",
    downloadPDF:       "Descargar PDF",
    downloadPDFDesc:   "Formato profesional listo",
    talentLabel:       "Talent Pool",
    talentTitle:       "Descubre talento top",
    talentSubtitle:    "Explora profesionales disponibles y encuentra el candidato ideal para tu empresa.",
    talentFilters:     "Filtros",
    talentLocation:    "Ubicación",
    talentSkills:      "Habilidades",
    talentIndustry:    "Industria",
    talentMinExp:      "Exp. mínima",
    talentAnyExp:      "Cualquiera",
    talentApply:       "Aplicar",
    talentClear:       "Limpiar",
    talentNoResults:   "No se encontraron candidatos",
    talentNoResultsDesc: "Los candidatos aparecen aquí cuando activan \"Disponible para trabajar\"",
    talentBrowseAll:   "Ver todo el talento",
    talentViewProfile: "Ver Perfil",
    talentYearsExp:    "años exp",
    talentFresher:     "Sin experiencia",
    talentShowing:     "Mostrando",
    talentOf:          "de",
    talentCandidates:  "candidatos",
    quickPostLabel:    "Para Empleadores",
    quickPostTitle:    "Publica un empleo en 60 segundos",
    quickPostSubtitle: "Llega a miles de candidatos calificados y encuentra el talento ideal más rápido.",
    quickPostFree:     "Publicación gratuita",
    quickPostInstant:  "Visibilidad inmediata",
    quickPostAI:       "Matching con IA",
    quickPostBtn:      "Publicar Empleo",
    quickPostTitle2:   "Título del puesto",
    quickPostLocation: "Ciudad o ubicación",
    quickPostCompany:  "Nombre de la empresa",
    signUpCandidate:   "Regístrate como candidato →",
  },

  /* ── Company Dashboard form ─────────────────────────── */
  postJobLabels: {
    newListing:        "Nuevo Anuncio",
    postJobTitle:      "Publicar un Empleo",
    jobTitleLabel:     "Título del Puesto",
    locationLabel:     "Ubicación",
    currentLocationLabel: "Ubicación actual",
    categoryLabel:     "Categoría",
    categoryOtherPlaceholder: "Escribí la categoría",
    jobTypeLabel:      "Tipo de Empleo",
    jobTypeOtherPlaceholder: "Escribí el tipo de empleo",
    experienceLabel:   "Nivel de Experiencia",
    experienceOtherPlaceholder: "Escribí el nivel de experiencia",
    salaryMinLabel:    "Salario Mínimo",
    salaryMaxLabel:    "Salario Máximo",
    descriptionLabel:  "Descripción del Puesto",
    requirementsLabel: "Requisitos",
    benefitsLabel:     "Beneficios",
    externalLinkLabel: "Enlace Externo (opcional)",
    isRemote:          "Es un puesto remoto",
    urgencyLabel:      "Inmediatez",
    urgencyNormal:     "Empleo normal",
    urgencyToday:      "Necesito cubrirlo hoy",
    urgencyUrgent:     "Urgente",
    shiftLabelPlaceholder: "Turno u horario (opcional, ej. Tarde 16-22h)",
    addRequirement:    "+ Agregar requisito",
    addBenefit:        "+ Agregar beneficio",
    publishBtn:        "Publicar Anuncio",
    successMsg:        "¡Empleo publicado! Redirigiendo...",
    remotePosition:    "Posición remota",
    management:        "Gestión",
    listings:          "Anuncios activos",
    newJob:            "Nuevo Empleo",
    viewJob:           "Ver empleo",
    applicants:        "postulantes",
    views:             "visitas",
    posted:            "Publicado",
    closeJob:          "¿Cerrar este anuncio?",
    active: "Activo", paused: "Pausado", closed: "Cerrado",
    editJobTitle: "Editar Empleo", updateBtn: "Guardar Cambios", cancelEditBtn: "Cancelar Edición",
    // Sprint: mejora de Publicar Empleo (salario, modalidad, urgencia, postulación, IA, preview)
    salaryPeriodLabel: "Período del salario",
    periodHour: "Por hora", periodMonth: "Por mes", periodYear: "Por año",
    hideSalaryLabel: "No mostrar salario",
    workModeLabel: "Modalidad",
    workModeOnsite: "Presencial", workModeHybrid: "Híbrido", workModeRemote: "Remoto",
    remoteCountriesLabel: "¿Desde qué países puede trabajar el candidato?",
    addressLabel: "Dirección exacta (opcional)",
    addressPlaceholder: "Calle y número, ej: Calle Colón 15",
    addressHint: "Solo se usa para ubicar el pin en el mapa con precisión — no se muestra públicamente en la oferta.",
    urgencyImmediate: "Incorporación inmediata",
    applicationMethodLabel: "¿Cómo recibirás las postulaciones?",
    applyMethodInternal: "Recibir postulaciones en InfoCityJobs",
    applyMethodExternal: "Redirigir a un sitio externo",
    externalLinkInvalid: "Ingresa una URL válida (debe empezar con http:// o https://)",
    improveWithAI: "✨ Mejorar con IA",
    improvingWithAI: "Mejorando con IA...",
    aiImproveModalTitle: "Propuesta mejorada con IA",
    aiImproveOriginal: "Tu texto original",
    aiImproveProposal: "Propuesta de la IA",
    aiImproveAccept: "Usar esta versión",
    aiImproveCancel: "Cancelar",
    aiImproveError: "No se pudo mejorar la descripción. Intenta nuevamente.",
    aiImproveEmptyError: "Escribe una descripción antes de mejorarla con IA.",
    previewBtn: "Vista previa",
    backToEditBtn: "Volver a editar",
    publishFinalBtn: "Publicar empleo",
    saveChangesFinalBtn: "Guardar cambios",
    previewSectionTitle: "Así verá el candidato tu publicación",
    confidentialCompanyLabel: "Empresa confidencial",
    previewSalaryHidden: "Salario no visible para candidatos",
  },
  geo: {
    countryLabel: "País",
    countryPlaceholder: "Selecciona un país",
    cityLabel: "Ciudad / Localidad",
    cityPlaceholder: "Empieza a escribir para buscar...",
    cityNoResults: "No encontramos coincidencias. Puedes escribir la ubicación igualmente.",
    cityHint: "Selecciona una sugerencia para verificar la ubicación en el mapa.",
    currencyLabel: "Moneda",
    currencyPlaceholder: "Selecciona una moneda",
    locationVerifiedBadge: "Ubicación verificada",
    locationUnverifiedBadge: "Sin verificar en el mapa",
    admin1LabelByKey: {
      comunidadAutonoma: "Comunidad Autónoma", departamento: "Departamento",
      estado: "Estado", provincia: "Provincia",
    },
    admin1PlaceholderByKey: {
      comunidadAutonoma: "Selecciona una comunidad autónoma", departamento: "Selecciona un departamento",
      estado: "Selecciona un estado", provincia: "Selecciona una provincia",
    },
    admin2Label: "Provincia",
    admin2Placeholder: "Selecciona una provincia",
    anyCountry: "Cualquier país",
    anyRegion: "Cualquier región",
    anyProvince: "Cualquier provincia",
    done: "Listo",
    countryNames: { ES: "España", UY: "Uruguay", US: "Estados Unidos", AR: "Argentina", BR: "Brasil" },
    currencyNames: { EUR: "Euro", USD: "Dólar estadounidense", UYU: "Peso uruguayo", ARS: "Peso argentino", BRL: "Real brasileño" },
  },
};

export default es;

es.common = { close: "Cerrar", seeAll: "Ver todos" };
es.share = { intro: "Mirá este empleo en InfoCityJobs:", linkCopied: "Enlace copiado" };
es.cvSuggestions = {
  add_summary: "Agrega o amplía tu resumen profesional",
  add_more_experience: "Agrega más experiencias laborales",
  add_experience: "Agrega al menos una experiencia laboral",
  add_more_skills: "Agrega más habilidades relevantes (mínimo 6)",
  add_skills: "Agrega habilidades técnicas y blandas",
  add_education: "Agrega tu formación académica",
  add_linkedin: "Agrega tu perfil de LinkedIn",
  add_languages: "Agrega los idiomas que hablas",
  add_certifications: "Agrega certificaciones profesionales",
};
